<template>
	<div>
		<el-row>
			<el-button
				size="small"
				class="pull-right"
				type="primary"
				@click="handleSearch"
			>搜索</el-button
			>
			<el-col class="pull-right" style="width: 200px; margin-right: 20px;">
				<el-input
					size="small"
					v-model="params.name"
					placeholder="等级"
				></el-input>
			</el-col>
		</el-row>
		<el-table v-loading="loading" :data="dataList">
			<el-table-column prop="user_score_rule_id" label="等级"></el-table-column>
			<el-table-column prop="remark" label="备注"></el-table-column>
<!--			<el-table-column label="操作" width="180">-->
<!--				<template slot-scope="row">-->
<!--					<el-button type="primary" size="small" @click="handleChange(row)"-->
<!--					>编辑</el-button>-->
<!--				</template>-->
<!--			</el-table-column>-->
		</el-table>
		<el-pagination
			background
			:page-size="dataMeta.per_page || 15"
			:total="dataMeta.total || 0"
			:current-page="page"
			@current-change="handlePageChange"
		></el-pagination>
		<el-dialog
			:visible.sync="visible"
			:title="isEdit ? '添加箱子' : '编辑箱子'"
			width="800px"
			:close-on-click-modal="false"
		>
			<el-form :model="formData" label-width="100px" :rules="rules" ref="form">
				<el-form-item prop="prize_id" label="箱子">
					<div class="prize-item" v-for="item in selectedBoxes.prize_rule.boxes" :key="item.id">
						<i class="el-icon-delete"></i>
						<img :src="item.box.image" alt />
						<p>
							<span>{{ item.box.name }}</span>
						</p>
						<p>
							<span class="price">{{ item.box.price }}</span>
						</p>
					</div>
					<div class="add-prize" @click="choseBox()">
						<i class="el-icon-plus"></i>
						<p>选择奖品</p>
					</div>
				</el-form-item>
				<el-form-item prop="display_probability" label="经验数">
					<el-input
						v-model="selectedBoxes.prize_rule.exp"
						placeholder="获得上面奖品所需经验数"
					></el-input>
				</el-form-item>
				<el-form-item prop="weight" label="备注">
					<el-input v-model="selectedBoxes.remark" placeholder="备注"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
        <el-button size="small" @click="visible = false">取 消</el-button>
        <el-button
					size="small"
					type="primary"
					@click="submit"
					:loading="buttonLoading"
				>确 定</el-button
				>
      </span>
		</el-dialog>
		<el-dialog
			:visible.sync="visibleBox"
			title="箱子列表"
			:close-on-click-modal="false"
			width="930px"
		>
			<el-row style="margin-bottom: 20px;">
				<el-input style="width: 200px; margin-right: 20px;" placeholder="奖品名称搜索" v-model="boxName"></el-input>
				<el-button type="primary" @click="getBoxes">搜索</el-button>
			</el-row>
			<div class="prize-list-wrap" v-loading="loadingBox">
				<ul class="prize-list">
					<li class="prize-item" v-for="b in boxListData" :key="b.id">
						<i
							class="el-icon-plus"
							title="添加"
							@click="handleAddBox(b)"
						></i>
						<img :src="b.image" alt />
						<p>
							<span>{{ b.name }}</span>
						</p>
						<p>
							<span class="price">{{ b.price }}</span>
						</p>
					</li>
				</ul>
			</div>
			<el-pagination
				background
				:page-size="boxListMeta.per_page || 15"
				:total="boxListMeta.total || 0"
				:current-page="prizePage"
				@current-change="handlePrizePageChange"
				v-if="boxListMeta && boxListMeta.total >boxListMeta.per_page"
			></el-pagination>
		</el-dialog>
	</div>
</template>

<script>
	import { getData, patchData } from '../../http'
	import { mapState } from 'vuex'
	export default {
		data() {
			return {
				loading: false,
				params: {
					name: '',
					page: 1
				},
				formData: {
					prize_rule: '',
					remark: ''
				},
				rules: {
					box_ids: [{ required: true, message: '请选择箱子' }],
					exp: [{ required: true, message: '请输入经验' }],
					remark: [{ required: true, message: '请输入备注' }]
				},
				visibleChange: false,
				editInfo: undefined,
				buttonLoading: false,
				dataList: undefined,
				dataMeta: {},
				page: 1,
				boxPage: 1,
				isEdit: false,
				boxName: '',
				visible: false,
				visibleBox: false,
				loadingBox: false,
				boxList: undefined,
				boxListData: undefined,
				boxListMeta: {},
				selectedBoxes: {
					'remark': '',
					'prize_rule': [
						{ 'exp': '', 'boxes': [] }
					]
				}
			}
		},
		computed: {
			...mapState({
				listData: state => state.data.userExpRules.data,
				listMeta: state => state.data.userExpRules.meta
			})
		},
		watch: {
			visibleChange(val) {
				if (val) {
					const {
						prize_rule,
						remark
					} = this.editInfo
					this.formData = {
						prize_rule,
						remark
					}
				}
			}
		},
		methods: {
			getTableData() {
				this.loading = true
				getData(`user_exp_rules`, this.params)
					.then(res => {
						this.dataList = res.data
						this.dataMeta = res.meta
					})
					.finally(() => {
						this.loading = false
					})
			},
			handlePageChange(page) {
				this.params.page = page
				this.getTableData()
			},
			handleSearch() {
				this.params.page = 1
				this.getTableData()
			},
			handleChange(row) {
				this.isEdit = true
				this.editInfo = row
				this.visible = true
				this.selectedBoxes = row.row
				this.formData = {
					'prize_rule': row.row.prize_rule,
					'remark': row.row.remark
				}
			},
			submit() {
				this.buttonLoading = true
				patchData(`user_exp_rules/${this.editInfo.id}`, {
					...this.formData
				})
					.then(res => {
						this.$message.success('修改成功')
						this.visibleChange = false
						this.getTableData()
					})
					.finally(() => {
						this.buttonLoading = false
					})
			},
			choseBox() {
				this.visibleBox = true
				this.getBoxes()
			},
			getBoxes() {
				this.loadingBox = true
				getData(`box`, { category_id: 2, page: this.boxPage, name: this.boxName })
					.then(res => {
						this.boxListData = res.data
						this.boxListMeta = res.meta
					})
					.finally(() => {
						this.loadingBox = false
					})
			},
			handleAddBox(row) {
				let temp = [{ box_id: row.id, nums: 1, box: row }]
				this.formData.prize_rule.boxes.push(...temp)
				this.selectedPrize = row
				this.visiblePrize = false
				this.formData.prize_rule = ''
			}
		},
		created() {
			this.getTableData()
		}
	}
</script>

<style>
</style>
